import { render, staticRenderFns } from "./AddEditSFDASources.vue?vue&type=template&id=c6e30b6e"
import script from "./AddEditSFDASources.vue?vue&type=script&lang=js"
export * from "./AddEditSFDASources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports